import classNames from "classnames";
import { useTableStyles } from "../commonStyles/tableStyles";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles((theme, { height, highlightOnHover }) => ({
    table: {
        "& tbody tr": {
            height: heights[height],
            transition: theme.transitions.create("background", { duration: theme.transitions.duration.shortest }),
            "@media (hover: hover)": {
                "&:hover": {
                    background: highlightOnHover && theme.palette.tertiary.lighter,
                }
            }
        },
        "& tbody td": {
            padding: theme.spacing(1, 0)
        }
    }
}));

const heights = {
    md: 60,
    sm: 45
};

export const Table = ({ headers, children, className, height, highlightOnHover, ...rest }) => {
    const classes = useStyles({ height, highlightOnHover });
    const tableClasses = useTableStyles();

    return (
        <table className={classNames(tableClasses.table, classes.table, className)} {...rest}>
            {headers && (
                <thead>
                    <tr>{headers}</tr>
                </thead>
            )}
            <tbody>
                {children}
            </tbody>
        </table>
    );
};
